export default __webpack_public_path__ + "static/media/bg_head3.10fc4215.jpg";